import { ReactElement } from 'react';

import DashboardVariantV2GiverContentFinalizedTabProvider from './Context';

import {
  DashboardVariantV2GiverContentTabContainer,
  DashboardVariantV2GiverContentWrapper,
} from '../../styles';

import {
  DashboardVariantV2GiverContentFinalizedTabActions,
  DashboardVariantV2GiverContentFinalizedTabCurrentFilters,
  DashboardVariantV2GiverContentFinalizedTabDataTable,
} from './Components';

const DashboardVariantV2GiverContentFinalizedTab = (): ReactElement => (
  <DashboardVariantV2GiverContentFinalizedTabProvider>
    <DashboardVariantV2GiverContentTabContainer>
      <DashboardVariantV2GiverContentFinalizedTabActions />

      <DashboardVariantV2GiverContentFinalizedTabCurrentFilters />

      <DashboardVariantV2GiverContentWrapper>
        <DashboardVariantV2GiverContentFinalizedTabDataTable />
      </DashboardVariantV2GiverContentWrapper>
    </DashboardVariantV2GiverContentTabContainer>
  </DashboardVariantV2GiverContentFinalizedTabProvider>
);

export default DashboardVariantV2GiverContentFinalizedTab;
